import React from 'react';
import { CMSIconFeature, CMSIconFeatureAttributes, CMSIconFeatures } from './types';
import IconFeaturesImpl from '@components/tailwind/IconFeatures';
import cx from '@utils/cx.util';
import { Markdown as MD } from '@features/markdown/components/Markdown';

type Props = {
  component: CMSIconFeatures;
};

const IconFeatures = ({ component }: Props) => {
  const {
    children,
    attributes: { title, smallPrint },
  } = component;

  return (
    <div className='tw:py-5 tw:md:px-5 tw:md:py-10'>
      {title && (
        <h2 className='tw:mb-4 tw:text-center tw:text-lg tw:font-bold tw:md:mb-6 tw:md:text-2xl'>{title}</h2>
      )}

      <div
        className={cx(
          'tw:mx-auto tw:grid tw:w-full tw:max-w-[600px] tw:grid-cols-2 tw:justify-center tw:gap-5 tw:lg:max-w-[1225px] tw:lg:justify-between',
          {
            'tw:lg:grid-cols-3': children.length === 3 || children.length > 4,
            'tw:lg:grid-cols-4': children.length === 4,
          }
        )}>
        {children.map((child, index) => {
          return (
            <IconFeatureItem
              key={index}
              {...child.attributes}
              className={cx('tw:mx-auto', {
                'tw:col-span-2 tw:lg:col-span-1': children.length % 2 === 1 && index === children.length - 1,
              })}
            />
          );
        })}
      </div>
      {!!smallPrint && (
        <div className='tw:mx-auto tw:mt-10 tw:text-center tw:text-[11px] tw:italic tw:lg:mt-14 tw:lg:text-[13px]'>
          {smallPrint}
        </div>
      )}
    </div>
  );
};

export default IconFeatures;

const IconFeatureItem = ({
  image,
  title,
  description,
  className = '',
}: CMSIconFeatureAttributes & { className: string }) => {
  return (
    <div className={cx('tw:max-w-[250px] tw:text-center', className)}>
      <img
        src={image.url}
        alt={title}
        className='tw:mx-auto tw:mb-4 tw:block tw:h-full tw:max-h-[50px] tw:w-full tw:max-w-[70px]'
      />
      <MD source={title} unwrapParagraphs className='tw:mb-2 tw:text-base tw:font-bold tw:md:text-lg' />
      <MD
        source={description}
        className='tw:mb-0 tw:text-sm tw:font-normal tw:leading-tight tw:md:text-base'
      />
    </div>
  );
};
